import { jsx as _jsx } from "react/jsx-runtime";
import { TimePicker as TimePickerMUI } from '@mui/x-date-pickers/TimePicker';
import { useEffect, useRef, useState } from 'react';
export const TimePicker = (props) => {
    const inputRef = useRef(null);
    const [inputWidth, setInputWidth] = useState(0);
    useEffect(() => {
        var _a;
        const timePicker = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        setInputWidth((timePicker === null || timePicker === void 0 ? void 0 : timePicker.width) || 0);
    }, [inputRef]);
    return (_jsx(TimePickerMUI, Object.assign({ ref: inputRef, slotProps: {
            layout: {
                sx: {
                    width: inputWidth,
                    '& .MuiMultiSectionDigitalClockSection-root': {
                        flexGrow: 1,
                        /*
                    this property is not supported in Safari
                    see: https://caniuse.com/mdn-css_properties_scrollbar-gutter
                    */
                        scrollbarGutter: 'stable',
                    },
                },
            },
            digitalClockSectionItem: {
                sx: {
                    width: 'auto',
                },
            },
        } }, props)));
};
